import { PersonLink } from '@/components/features/person-link'

export type TodoPersonChipPerson = {
  id?: string | number
  name?: string
  avatar_url?: string
}

export function TodoPersonChip({ person }: { person: TodoPersonChipPerson }) {
  const name = person.name || 'Unknown'
  return (
    <div className="inline-flex items-center gap-1.5 rounded-md border border-border bg-card px-2 py-1 hover:bg-muted transition-colors">
      {person.avatar_url ? (
        <img
          src={person.avatar_url}
          alt={name}
          className="h-5 w-5 flex-shrink-0 rounded-full"
        />
      ) : (
        <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-muted text-[10px] font-medium text-muted-foreground">
          {name[0].toUpperCase()}
        </div>
      )}
      <PersonLink
        name={name}
        basecampPersonId={person.id}
        className="whitespace-nowrap text-xs font-medium text-foreground"
      />
    </div>
  )
}
